export default __webpack_public_path__ + "static/media/nftDetail.b611029a.png";